export const TO_RESERVE = (id) => `/warehouse/reserves/${id}`;
export const TO_ENTRY = (id) => `/warehouse/entries/${id}`;
export const TO_PRODUCT = (id) => `/warehouse/products/${id}`;
export const TO_ONE_RETURN_RECEIVE = (id) => `/warehouse/returns_by_days/${id}`;

export const TO_POSING = (number) => `/shipment/posting/${number}`;
export const TO_SHIPMENT = (id) => `/shipment/shipments/${id}`;
export const TO_SUPPLY = (id) => `/fbo/supplies/${id}`;
export const TO_ORDER = (id) => `/shipment/orders/${id}`;

export const TO_SELLARY = (userId, periodId) => `/user/profile/${userId}/${periodId}`;
export const TO_PROFILE = (userId) => `/user/profile/${userId}`;

export const TO_REALIZATION = (id) => `/report/realizations/${id}`;
export const TO_REPORT = (id) => `/report/reports/${id}`;
export const TO_RETURNS_REPORT = (id) => `/report/returns/${id}`;

export const TO_PROVIDER_PRODUCT = (sku) => `/provider/product/${sku}`;

export const TO_SUPPLIE = (market, id) => `/orders/wb/supplies/${market}/${id}`;

export const TO_STATISTIC_SHIPMENT = (id) => `/statistic/shipments/${id}`;


export const C_ACTION = {
  ADD: 'ADD',
  DELETE: 'DELETE',
  CHANGE: 'CHANGE',
  INIT: 'INIT',

  CHANGE_ORDER: 'CHANGE_ORDER',

  CHANGE_PRODUCT_PROVIDER: 'CHANGE_PRODUCT_PROVIDER',
  CHANGE_PRODUCT_CATEGORY: 'CHANGE_PRODUCT_CATEGORY',
  CHANGE_PRODUCT_SKU: 'CHANGE_PRODUCT_SKU',
  CHANGE_PRODUCT_NUM: 'CHANGE_PRODUCT_NUM',
  CHANGE_PRODUCT_SKU_QUANTITY: 'CHANGE_PRODUCT_SKU_QUANTITY',

  CHANGE_ORDER_PROVIDER: 'CHANGE_ORDER_PROVIDER',
  CHANGE_ORDER_CATEGORY: 'CHANGE_ORDER_CATEGORY',
  COLLECT_ORDERS: 'COLLECT_ORDERS',
  ADD_ORDERS: 'ADD_ORDERS',
  DELETE_ORDERS: 'DELETE_ORDERS',
  ADD_ALL_ORDERS: 'ADD_ALL_ORDERS',

  ADD_ALL_ORDERS_GROUPED: 'ADD_ALL_ORDERS_GROUPED',
  DELETE_ALL_ORDERS: 'DELETE_ALL_ORDERS',

  ADD_PROVIDERS: 'ADD_PROVIDERS',
  ADD_ONE_PROVIDER: 'ADD_ONE_PROVIDER',
  DELETE_PROVIDER: 'DELETE_PROVIDER',
  CHANGE_PROVIDER: 'CHANGE_PROVIDER',

  ADD_COLLECTIONS: 'ADD_COLLECTIONS',
  DELETE_COLLECTION: 'DELETE_COLLECTION',
  CHANGE_COLLECTIONS: 'CHANGE_COLLECTIONS',

  ADD_ASSEMBLIES: 'ADD_ASSEMBLIES',
  ADD_ASSEMBLY: 'ADD_ASSEMBLY',
  CHANGE_ASSEMBLIES: 'CHANGE_ASSEMBLIES',

  ADD_USER: 'ADD_USER',
  REMOVE_USER: 'REMOVE_USER',
  CHANGE_USER: 'CHANGE_USER',

  ADD_STAFF: 'ADD_STAFF',
  ADD_STAFF_AVATARS: 'ADD_STAFF_AVATARS',

  ADD_ONE_STAFF: 'ADD_ONE_STAFF',
  DELETE_STAFF: 'DELETE_STAFF',
  CHANGE_STAFF: 'CHANGE_STAFF',

  UI_CHANGE_SELECT_PROVIDER: 'CHANGE_SELECT_PROVIDER',

  ADD_HELPERDATA: 'ADD_HELPERDATA',
  DELETE_HELPER: 'DELETE_HELPER',

  UI_CHANGE_WB_VIEW_SIZE: 'UI_CHANGE_WB_VIEW_SIZE',
  UI_CHANGE_SHIPMENT_MODE: 'UI_CHANGE_SHIPMENT_MODE',
  UI_CHANGE_SKLADNAME: 'UI_CHANGE_SKLADNAME',
  UI_USERS_AVATARS: 'UI_USERS_AVATARS',

  SET_NEW_CONTROLLER: 'SET_NEW_CONTROLLER',

  ADD_PACKAGE: 'ADD_PACKAGE',
};

export const TYPE_BUTTONS = {
  BLUE: 'blue',
  WHITE: 'white',
  GREY: 'grey',
  GREEN: 'green',
  RED: 'red',
  ORANGE: 'orange',
};

export const TYPE_INPUT = {
  BLUE: 'BLUE',
};

export const POP_UP_CONTAINER_ID = 'pop-up-field';








export const SHIPMENT_STATUS = {
  NEW: 'new',
  READY: 'not started',
  STARTED: 'started',
  END: 'ended',
};

export const SHIPMENT_STATUS_TEXT = {
  'new': 'Создана',
  'not started': 'Отгрузка не начата',
  'started': 'Отгрузка начата',
  'ended': 'Отгрузка закончена',
};

export const REALIZATION_STATUS = {
  'started': 'В работе',
  'ended': 'Завершена',
  'not started': 'Не начата',
};












export const REPORT_TYPE = {
  system: 'Ежедневный',
  report: 'Подотчётный',
};

export const REPORT_STATUS_TEXT = {
  new: 'Не обработан',
  confirmed: 'Проведен',
};

export const REPORT_TYPE_TEXT = {
  Основной: 'Основной',
  Выкупной: 'Выкупной',
};

export const REPORTS_STATUS_TEXT = {
  'new': 'Не обработан',
  'not started': 'Отгрузка не начата',
  'started': 'Отгрузка начата',
  'ended': 'Отгрузка закончена',
};














export const RESERVES_STATUS = {
  new: 'Новый',
  started: 'Собирается',
  ended: 'Закрыт',
};

export const ENTRIES_STATUS = {
  new: 'В работе',
  ended: 'Завершено',
};












export const STATUS_COLORS = {
  'Отгружено на воротах': '#7f7f1eff',
  'Идёт приёмка': '#7a9b49fe',
  'Принято': '#429f43',
  
  'not started': '#d02529',
  started: 'rgb(220 137 9)',
  ended: '#429f43',
  new: '#d02529',
  confirmed: '#429f43',
  not_started: '#d02529',
};

export const RESERVES_STATUS_COLORS = {
  new: '#d02529',
  started: '#ffae32',
  ended: '#429f43',
};


export const ENTRIES_STATUS_COLORS = {
  new: '#8b8821ff',
  ended: '#429f43',
};


export const OZON_1 = 'OZON-1';
export const OZON_2 = 'OZON-2';
export const B_MAX_EXPRESS = 'OZON-2 EXPRESS';
export const OZON_3 = 'OZON-3';
export const OZON_4 = 'OZON-4';
export const OZON_5 = 'OZON-5';
export const OZON_6 = 'OZON-6';
export const OZON_7 = 'OZON-7';
export const OZON_1_EKB = 'OZON-1_EKB';
export const OZON_2_EKB = 'OZON-2_EKB';
export const OZON_3_EKB = 'OZON-3_EKB';
export const OZON_4_EKB = 'OZON-4_EKB';
export const OZON_5_EKB = 'OZON-5_EKB';
export const OZON_6_EKB = 'OZON-6_EKB';
export const OZON_7_EKB = 'OZON-7_EKB';

export const OZON_1_FBO = 'OZON-1_FBO';
export const OZON_2_FBO = 'OZON-2_FBO';
export const OZON_3_FBO = 'OZON-3_FBO';
export const OZON_4_FBO = 'OZON-4_FBO';
export const OZON_5_FBO = 'OZON-5_FBO';
export const OZON_6_FBO = 'OZON-6_FBO';
export const OZON_7_FBO = 'OZON-7_FBO';

export const MEGAMARKET_1 = 'MM-1';
export const MEGAMARKET_2 = 'MM-2';

export const AVITO_1 = 'AVITO-1';

export const WB_1 = 'WB-1';
export const WB_2 = 'WB-2';
export const WB_3 = 'WB-3';
export const WB_4 = 'WB-4';
export const WB_5 = 'WB-5';
export const WB_6 = 'WB-6';
export const WB_7 = 'WB-7';
export const WB_1_EKB = 'WB-1_EKB';
export const WB_2_EKB = 'WB-2_EKB';
export const WB_3_EKB = 'WB-3_EKB';
export const WB_4_EKB = 'WB-4_EKB';
export const WB_5_EKB = 'WB-5_EKB';
export const WB_6_EKB = 'WB-6_EKB';
export const WB_7_EKB = 'WB-7_EKB';

export const YANDEX_1 = 'YANDEX-1 FBS';
export const YANDEX_2 = 'YANDEX-2 EXPRESS';
export const YANDEX_3 = 'YANDEX-3';
export const YANDEX_4 = 'YANDEX-4';
export const YANDEX_5 = 'YANDEX-5';
export const YANDEX_6 = 'YANDEX-6';
export const YANDEX_7 = 'YANDEX-7';
export const YANDEX_8 = 'YANDEX-8 EXPRESS';
export const YANDEX_1_EKB = 'YANDEX-1_EKB';
export const YANDEX_3_EKB = 'YANDEX-3_EKB';
export const YANDEX_4_EKB = 'YANDEX-4_EKB';
export const YANDEX_5_EKB = 'YANDEX-5_EKB';
export const YANDEX_7_EKB = 'YANDEX-7_EKB';

export const MARKETS_ALL = {
  ozon: [OZON_1, OZON_2, OZON_3, OZON_4, OZON_5, OZON_6, OZON_7],
  yandex: [YANDEX_1, YANDEX_3, YANDEX_4, YANDEX_5, YANDEX_6, YANDEX_7, YANDEX_8],
  wb: ['WB-1', 'WB-2', 'WB-3', 'WB-4', 'WB-5', 'WB-6', 'WB-7'], //['wb 1-5'], //
  megamarket: ['MM-1', 'MM2'], //['wb 1-5'], //
  avito: ['AVITO'],
};

export const SBER_1 = 'MM-1';
export const SBER_2 = 'MM-2';

export const MM_1 = 'MM-1';
export const MM_2 = 'MM-2';

export const WB_MARKET_IP = {
  [WB_1]: 'ИП Макаров А.Н',
  [WB_2]: 'ИП Макаров Н.Н',
  [WB_3]: 'ИП Макарова А.С',
  [WB_4]: 'ИП Кравец С.П',
  [WB_5]: 'ИП Гудилина И.А.',
  [WB_6]: 'ИП Кравец Т.C.',
  [WB_7]: 'ИП Гудилина Д.О.',
};

export const YANDEX_MARKET_NAME = {
  [YANDEX_1]: 'YANDEX-1',
  [YANDEX_2]: 'YANDEX-1 EXPRESS',
  [YANDEX_3]: 'YANDEX-3',
  [YANDEX_4]: 'YANDEX-4',
  [YANDEX_5]: 'YANDEX-5',
  [YANDEX_6]: 'YANDEX-6',
  [YANDEX_7]: 'YANDEX-7',
  [YANDEX_8]: 'YANDEX-8 EXPRESS',
  [YANDEX_1_EKB]: 'YANDEX-1 EKB',
  [YANDEX_3_EKB]: 'YANDEX-3 EKB',
  [YANDEX_4_EKB]: 'YANDEX-4 EKB',
  [YANDEX_5_EKB]: 'YANDEX-5 EKB',
  [YANDEX_7_EKB]: 'YANDEX-7 EKB',
};

export const YANDEX_MARKET_IP = {
  [YANDEX_1]: 'ИП Макаров Н.Н, FBS',
  [YANDEX_2]: 'ИП Макаров Н.Н, EXPRESS',
  [YANDEX_3]: 'ИП Кравец А.С',
  [YANDEX_4]: 'ИП Кравец С.П',
  [YANDEX_5]: 'ИП Гудилина И.А.',
  [YANDEX_6]: 'ИП Гудилина Т.C.',
  [YANDEX_7]: 'ИП Гудилина Д.О.',
  [YANDEX_8]: 'ИП Макаров А.Н',
};

export const OZON_MARKETS = {
  [OZON_1]: OZON_1,
  [OZON_2]: OZON_2,
  [OZON_3]: OZON_3,
  [OZON_4]: OZON_4,
  [OZON_5]: OZON_5,
  [OZON_6]: OZON_6,
  [OZON_7]: OZON_7,
};

export const OZON_MARKETS_MAP = {
  [OZON_1]: 'ozon1',
  [OZON_2]: 'ozon2',
  [OZON_3]: 'ozon3',
  [OZON_4]: 'ozon4',
  [OZON_5]: 'ozon5',
  [OZON_6]: 'ozon6',
  [OZON_7]: 'ozon7',
  [OZON_1_EKB]: 'ozon1',
  [OZON_2_EKB]: 'ozon2',
  [OZON_3_EKB]: 'ozon3',
  [OZON_4_EKB]: 'ozon4',
  [OZON_5_EKB]: 'ozon5',
  [OZON_6_EKB]: 'ozon6',
  [OZON_7_EKB]: 'ozon7',
  [OZON_1_FBO]: 'ozon1',
  [OZON_2_FBO]: 'ozon2',
  [OZON_3_FBO]: 'ozon3',
  [OZON_4_FBO]: 'ozon4',
  [OZON_5_FBO]: 'ozon5',
  [OZON_6_FBO]: 'ozon6',
  [OZON_7_FBO]: 'ozon7',
};

export const OZON_MARKETS_MAP_REVERSE = {
  'ozon1': [OZON_1],
  'ozon2': [OZON_2],
  'ozon3': [OZON_3],
  'ozon4': [OZON_4],
  'ozon5': [OZON_5],
  'ozon6': [OZON_6],
  'ozon7': [OZON_7],
};

export const WB_MARKETS_MAP = {
  [WB_1]: 'wb1',
  [WB_2]: 'wb2',
  [WB_3]: 'wb3',
  [WB_4]: 'wb4',
  [WB_5]: 'wb5',
  [WB_6]: 'wb6',
  [WB_7]: 'wb7',
  [WB_1_EKB]: 'wb1',
  [WB_2_EKB]: 'wb2',
  [WB_3_EKB]: 'wb3',
  [WB_4_EKB]: 'wb4',
  [WB_5_EKB]: 'wb5',
  [WB_6_EKB]: 'wb6',
  [WB_7_EKB]: 'wb7',
};

export const WB_MARKETS_MAP_REVERSE = {
  'wb1': [WB_1],
  'wb2': [WB_2],
  'wb3': [WB_3],
  'wb4': [WB_4],
  'wb5': [WB_5],
  'wb6': [WB_6],
  'wb7': [WB_7],
};

export const MAP_WB_SKLAD_NAME = {
  [WB_1]: 'msk',
  [WB_2]: 'msk',
  [WB_3]: 'msk',
  [WB_4]: 'msk',
  [WB_5]: 'msk',
  [WB_6]: 'msk',
  [WB_7]: 'msk',
  [WB_1_EKB]: 'ekb',
  [WB_2_EKB]: 'ekb',
  [WB_3_EKB]: 'ekb',
  [WB_4_EKB]: 'ekb',
  [WB_5_EKB]: 'ekb',
  [WB_6_EKB]: 'ekb',
  [WB_7_EKB]: 'ekb',
};

export const MAP_OZON_SKLAD_NAME = {
  [OZON_1]: 'msk',
  [OZON_2]: 'msk',
  [OZON_3]: 'msk',
  [OZON_4]: 'msk',
  [OZON_5]: 'msk',
  [OZON_6]: 'msk',
  [OZON_7]: 'msk',
  [OZON_1_EKB]: 'ekb',
  [OZON_2_EKB]: 'ekb',
  [OZON_3_EKB]: 'ekb',
  [OZON_4_EKB]: 'ekb',
  [OZON_5_EKB]: 'ekb',
  [OZON_6_EKB]: 'ekb',
  [OZON_7_EKB]: 'ekb',
  [OZON_1_FBO]: 'mp',
  [OZON_2_FBO]: 'mp',
  [OZON_3_FBO]: 'mp',
  [OZON_4_FBO]: 'mp',
  [OZON_5_FBO]: 'mp',
  [OZON_6_FBO]: 'mp',
  [OZON_7_FBO]: 'mp',
};

export const MAP_OZON_SKLAD_SALE_SCHAME = {
  [OZON_1]: 'fbs',
  [OZON_2]: 'fbs',
  [OZON_3]: 'fbs',
  [OZON_4]: 'fbs',
  [OZON_5]: 'fbs',
  [OZON_6]: 'fbs',
  [OZON_7]: 'fbs',
  [OZON_1_EKB]: 'fbs',
  [OZON_2_EKB]: 'fbs',
  [OZON_3_EKB]: 'fbs',
  [OZON_4_EKB]: 'fbs',
  [OZON_5_EKB]: 'fbs',
  [OZON_6_EKB]: 'fbs',
  [OZON_7_EKB]: 'fbs',
  [OZON_1_FBO]: 'fbo',
  [OZON_2_FBO]: 'fbo',
  [OZON_3_FBO]: 'fbo',
  [OZON_4_FBO]: 'fbo',
  [OZON_5_FBO]: 'fbo',
  [OZON_6_FBO]: 'fbo',
  [OZON_7_FBO]: 'fbo',
};
export const YANDEX_MARKETS_MAP_SKLAD = {
  [YANDEX_1]: 'msk',
  [YANDEX_2]: 'msk',
  [YANDEX_3]: 'msk',
  [YANDEX_4]: 'msk',
  [YANDEX_5]: 'msk',
  [YANDEX_6]: 'msk',
  [YANDEX_7]: 'msk',
  [YANDEX_8]: 'msk',
  [YANDEX_1_EKB]: 'ekb',
  [YANDEX_3_EKB]: 'ekb',
  [YANDEX_4_EKB]: 'ekb',
  [YANDEX_5_EKB]: 'ekb',
  [YANDEX_7_EKB]: 'ekb',
};

export const MAP_MM_SKLAD_NAME = {
  [MM_1]: 'msk',
  [MM_2]: 'ekb',
};

export const MAP_SKLAD_NAME = {
  ...MAP_OZON_SKLAD_NAME,
  ...MAP_WB_SKLAD_NAME,
  ...MAP_MM_SKLAD_NAME,
  ...YANDEX_MARKETS_MAP_SKLAD,
};

export const YANDEX_MARKETS_MAP = {
  [YANDEX_1]: 'yandex1',
  [YANDEX_2]: 'yandex2',
  [YANDEX_3]: 'yandex3',
  [YANDEX_4]: 'yandex4',
  [YANDEX_5]: 'yandex5',
  [YANDEX_6]: 'yandex6',
  [YANDEX_7]: 'yandex7',
  [YANDEX_8]: 'yandex8',
  [YANDEX_1_EKB]: 'yandex1',
  [YANDEX_3_EKB]: 'yandex3',
  [YANDEX_4_EKB]: 'yandex4',
  [YANDEX_5_EKB]: 'yandex5',
  [YANDEX_7_EKB]: 'yandex7',
};

export const MEGAMARKET_MARKETS_MAP = {
  [MEGAMARKET_1]: 'megamarket1',
  [MEGAMARKET_2]: 'megamarket2',
};

export const AVITO_MARKETS_MAP = {
  [AVITO_1]: 'avito1',
};

export const MARKETS_MAP = {
  ...WB_MARKETS_MAP,
  ...OZON_MARKETS_MAP,
  ...YANDEX_MARKETS_MAP,
  ...MEGAMARKET_MARKETS_MAP,
  ...AVITO_MARKETS_MAP,
};












export const YANDEX_STATUS = {
  '': 'Любой',
  PROCESSING: 'Обрабатывается',
  DELIVERY: 'Доставляется',
  CANCELLED: 'Отменён',
  DELIVERED: 'Доставлен',
  PICKUP: 'Доставлен', // заказ доставлен в пункт самовывоза.
  REJECTED: 'Товары зарезервированы',
  UNPAID: 'Ожидает оплаты',
};

export const SBER_STATUS = {
  '': 'Любой',
  NEW: 'Ожидает подтверждение',
  CONFIRMED: 'Можно комплектовать',
  PACKED: 'Готов к отгрузке',
  SHIPPED: 'Отгружены',
  DELIVERED: 'Доставлен', // заказ доставлен в пункт самовывоза.
  MERCHANT_CANCELED: 'Отмена продавцом',
  CUSTOMER_CANCELED: 'Отмена покупателем',
};



export const YANDEX_SUBSTATUS = {
  '': 'Любой',
  PROCESSING: {
    '': 'Любой',
    STARTED: 'Можно комплектовать',
    READY_TO_SHIP: 'Готов к отгрузке',
    SHIPPED: 'Передан службе доставки',
  },
  DELIVERED: '',
  DELIVERY: '',
  CANCELLED: {
    '': 'Любой',
    PROCESSING_EXPIRED: '',
    REPLACING_ORDER: '',
    RESERVATION_EXPIRED: '',
    SHOP_FAILED: '',
    USER_CHANGED_MIND: '',
    USER_NOT_PAID: '',
    USER_REFUSED_DELIVERY: '',
    USER_REFUSED_PRODUCT: '',
    USER_REFUSED_QUALITY: '',
    USER_UNREACHABLE: '',
  },

  PICKUP: '',
  REJECTED: '',
  UNPAID: '',
};

export const YANDEX_SUBSTATUS_ALL = {
  ...YANDEX_SUBSTATUS.CANCELLED,
  ...YANDEX_SUBSTATUS.PROCESSING,
};











export const USERS_LIST = {
  user: {
    role: 'user', // управляющие склада + контент
    name: 'Сотрудник магазина',
  },
  admin: {
    role: 'admin', // доступ к ценам
    name: 'Управляющий',
  },
  packer: {
    role: 'user',
    name: 'Сотрудник склада',
  },
  sorter: {
    role: 'sorter',
    name: 'Сортировщик',
  },
  content: {
    role: 'content',
    name: 'Контент-менеджер',
  },
  booker: {
    role: 'booker',
    name: 'Бухгалтер',
  },


};

export const ALL_USERS = {
  owner: {
    role: 'owner', // главная учетка
    name: 'Владелец',
  },
  ...USERS_LIST,
};











export const MARKET_MODES = ['Режим остатков', 'Режим цен', 'Режим контента', 'Режим FBS'];



export const PROVIDERS = {
  KOMUS: { id: 30, name: 'Комус' },
  SAMSON: { id: 2, name: 'Самсон' },
  SIMALAND: { id: 11, name: 'Сима-ленд' },
  GALA: { id: 37, name: 'Гала-центр' },
  RELEF: { id: 33, name: 'Рельеф-центр' },
};




export const DIFF_STATUSES = [
  'Брак',
  'Пересорт',
  'Недостача',
  'Вычерк',
  'Косяк склада',
  'Косяк контента',
  'Не нашли с резерва',
  'Нет в наличии',
  'Добавить в отгрузку',
  'Недостача докуп',
  'Отгружали',
  'Нет',
];

export const MARKETS_FILTER_DEFAULT = {
  ozon1: 'all',
  ozon2: 'all',
  ozon3: 'all',
  ozon4: 'all',
  ozon5: 'all',
  ozon6: 'all',
  ozon7: 'all',
  yandex1: 'all',
  yandex2: 'all',
  yandex3: 'all',
  yandex4: 'all',
  yandex5: 'all',
  yandex6: 'all',
  yandex7: 'all',
  yandex8: 'all',
  wb1: 'all',
  wb2: 'all',
  wb3: 'all',
  wb4: 'all',
  wb5: 'all',
  wb6: 'all',
  wb7: 'all',
  megamarket1: 'all',
  megamarket2: 'all',
};








export const MODES_CONTENT_TABLE_LIST = ['Режим остатков', 'Режим контента', 'Режим вб'];

export const MODES_CONTENT_TABLE = {
  STOCKS: 'Режим остатков',
  CONTENT: 'Режим контента',
  WB: 'Режим вб',
};

export const B_WHITE = 'B-WHITE';
export const B_MAX = 'B-MAX';
export const U_RURU = 'U_RURU';





export const RETURN_STATUS_LIST = [
  'Не выбран',
  'Получен',
  'В пути',
  'Готов к выдаче',
  'Привезёт курьер',
  'Принят от покупателя',
  'Утилизирован',
  'Отказ при получении',
  'Отмена по задержке',
];

export const RETURN_STATE = {
  new: 'Не обработан',
  confirmed: 'Обработан',
  partly: 'Частично обработан',
};

export const IP = {
  ARTEM: 'Макаров А.Н',
  ALENA: 'Макарова А.С',
  NIKOLAY: 'Макаров Н.Н',
  SVETANA: 'Кравец С.П',
  IRA: 'Гудилина И.А.',
  TARAS: 'Кравец Т.C.',
  DIANA: 'Гудилина Д.О.',
};

export const IP_NUMBER_MAP = {
  1: 'Макаров Н.Н.',
  2: 'Макаров А.Н.',
  3: 'Макарова А.С.',
  4: 'Кравец С.П.',
  5: 'Гудилина И.А.',
  6: 'Кравец Т.С.',
  7: 'Гудилина Д.О.',
};


export const IP_MAP = {
  1: { name: IP.NIKOLAY, id: 1 },
  2: { name: IP.ARTEM, id: 2 },
  3: { name: IP.ALENA, id: 3 },
  4: { name: IP.SVETANA, id: 4 },
  5: { name: IP.IRA, id: 5 },
  6: { name: IP.TARAS, id: 6 },
  7: { name: IP.DIANA, id: 7 },
};
export const IP_LIST_NUMBER = Object.keys(IP_MAP);
export const IP_LIST = Object.keys(IP_MAP).map((id) => IP_MAP[id]);

export const MARKET_IP = {
  ozon1: IP.NIKOLAY,
  ozon2: IP.ARTEM,
  ozon3: IP.ALENA,
  ozon4: IP.SVETANA,
  ozon5: IP.IRA,
  ozon6: IP.TARAS,
  ozon7: IP.DIANA,
  yandex1: IP.NIKOLAY,
  yandex2: IP.NIKOLAY,
  yandex3: IP.ALENA,
  yandex4: IP.SVETANA,
  yandex5: IP.IRA,
  yandex6: IP.TARAS,
  yandex7: IP.DIANA,
  yandex8: IP.ARTEM,
  wb1: IP.ARTEM,
  wb2: IP.NIKOLAY,
  wb3: IP.ALENA,
  wb4: IP.SVETANA,
  wb5: IP.IRA,
  wb6: IP.TARAS,
  wb7: IP.DIANA,
  megamarket1: IP.NIKOLAY,
  megamarket2: IP.ARTEM,
  kuper: IP.ARTEM,
};

export const WAREHOUSE_LIST = [
  { warehouse: 'Москва', name: 'msk' },
  { warehouse: 'Екатеринбург', name: 'ekb' },
];


export const MAP_SKLAD = {
  msk: 'Москва',
  ekb: 'Екатеринбург',
  mp: 'Марркетплейс',
};


export const MAP_RETURNS = {
  return: 'Возвраты',
  overage: 'Занесение с отгрузок',
  entrying: 'Занесение',
};

export const MAP_SKLAD_SHORT = {
  msk: 'Мск',
  ekb: 'Екб',
  mp: 'Склад МП',
};

export const MAP_SKLAD_SHORT_ANOTHER = {
  'Мск': 'msk',
  'Екб': 'ekb',
};

export const MAP_SKLAD_RUS = {
  Москва: 'msk',
  Екатеринбург: 'ekb',
};

export const MAP_SKLAD_RUS_ALL = {
  Москва: 'msk',
  Екатеринбург: 'ekb',
  Маркетплейс: 'mp',
  'Не определен': 'not_defined',
};

export const WAREHOUSES = ['Москва', 'Екатеринбург'];
export const SKLAD_LIST = ['Не выбран', ...WAREHOUSES];

export const SKLAD_LIST_ALL = ['Не выбран', ...WAREHOUSES, 'Маркетплейс'];

export const TYPE_RETURNS = ['Не выбран', 'Возврат', 'Невыкуп'];

export const SKLADS_WAREHOUSE = [
  { name: 'Москва', short_name: 'msk', address: 'Рябиновая 19' },
  { name: 'Екатеринбург', short_name: 'ekb', address: 'Мурзинская 27а' },
];

export const SKLADS_WAREHOUSE_MAP = {
  msk: { name: 'Москва', short_name: 'msk', address: 'Рябиновая 19' },
  ekb: { name: 'Екатеринбург', short_name: 'ekb', address: 'Мурзинская 27а' },
};

export const ANSWERS_WAREHOUSE = [
  'Ок',
  'Резерв',
  'Утеря',
  'Отмена',
  'Утеря + Отмена',
  'Потом добавят',
  'Камера',
  'Мехродж',
  'Ира',
  'Мехродж',
  'Миша',
  'Елена',
  'Светлана',
  'Алена',
  'Артем',
  'Тарас',
  'Нет',
];
